<template>
  <div :id="block.hash" class="bg-gray-200 dark:bg-gray-800 w-full group h-full" @click="handleEditBreak(block)">
    <div class="text-xs p-2">
      <p class="font-medium">
        {{ label }}
      </p>
      <p class="">
        {{ $date.minutes(block.startTime) }} - {{ $date.minutes(block.startTime + block.duration) }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
const { t: $t } = useI18n()

const handleEditBreak = inject('handleEditBreak') as Function

interface Props {
  block: any
}

const props = defineProps<Props>()

const label = computed(() => {
  const block = props.block.employeeBreak
  const hasLabel = block.label && block.label.length

  return hasLabel ? block.label : $t('schedule.break')
})
</script>
